import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=672022ba&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=672022ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672022ba",
  null
  
)

export default component.exports